import { queryOptions } from '@tanstack/react-query';
import { legacyOrderDraftApi } from './legacy-order-draft-api';

export const legacyOrderDraftKeys = {
  all: ['legacy-order-draft'] as const,
  equipments: () => [...legacyOrderDraftKeys.all, 'equipments'] as const,
  locations: (params: { search?: string; shopId?: string } = {}) =>
    [
      ...legacyOrderDraftKeys.all,
      'locations',
      params.search ?? '',
      params.shopId ?? '',
    ] as const,
};

export const legacyOrderDraftQueries = {
  equipments: () =>
    queryOptions({
      queryKey: legacyOrderDraftKeys.equipments(),
      queryFn: () => legacyOrderDraftApi.equipments(),
    }),
  locations: (params: { search?: string; shopId?: string } = {}) =>
    queryOptions({
      queryKey: legacyOrderDraftKeys.locations(params),
      queryFn: () => legacyOrderDraftApi.savedLocations(params),
    }),
};
